import { CommonModule, LowerCasePipe } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AdService } from '../../core/ad.service';
import { environment } from '../../../environments/environment';
import { globals } from '../../../environments/globals';

@Component({
    selector: 'ad-card',
    templateUrl: './ad-card.html',
    standalone: true,
    imports: [
        CommonModule,
        LowerCasePipe,
        RouterModule
    ]
})
export class AdCardComponent implements OnInit {
  appURL: string = environment.appURL;
  mediaURL: string = environment.mediaURL;
  @Input() id: string = '';
  @Input() uid: string = '';
  @Input() highlights: boolean = true;
  @Input() image: boolean = true;

  ad: any;
  directory: any = globals.directory;
  directory_data: any;
  watch: boolean = false;

  constructor(
    private as: AdService,
  ) {}

  ngOnInit() {
    if (this.id) {
      this.ad = this.as.adDetail(this.id).subscribe(ad => {
        this.ad = ad;
        if(this.ad.country) {
          this.directory_data = this.directory[this.ad.country];
        }
      })
    }
  }
}
